import { useAtom } from "jotai";
import Image from "next/legacy/image";
import { useRef, useState } from "react";

import { mentorData } from "./data";
import { useIntersection } from "@/businessLogics/_common/util-browser/useIntersection";
import DesktopDivider from "@/components/atoms/Divider/DesktopDivider/DesktopDivider";
import { mktOrientationModalAtom } from "../../../../states/orientation";

import * as S from "./MktLandingPageMentorOraganism.style";

export default function MktLandingPageMentorOraganism() {
  const mentorRef = useRef<HTMLDivElement>();
  const [isShown, setIsShown] = useState<boolean>(false);
  const [, setModal] = useAtom(mktOrientationModalAtom);

  const now = new Date();
  const modalOnTime = new Date(2023, 4, 2, 12);
  const showModal = now <= modalOnTime;

  const setModalOn = () => {
    if (!isShown) setIsShown(true);
    showModal && setModal(true);
  };
  useIntersection(mentorRef, setModalOn, [isShown], [0]);
  return (
    <S.Wrapper ref={mentorRef}>
      <S.Top>
        <S.Title>
          <>
            현업과 채용시장에 몸담고 있는 <br className="mkt" />
            팀스파르타 리더와 현직 시니어가 함께 합니다.
          </>
        </S.Title>
        <S.Desc>
          팀스파르타의 성공을 이끈 리더들, 다양한 산업군의 현직 마케터들이
          <DesktopDivider /> 직접 그 노하우를 전수합니다. 실전으로 단련된 생생한
          전략을 체득하세요.
        </S.Desc>
      </S.Top>
      <S.CardContainer>
        {mentorData.map(
          ({
            id,
            name,
            specialty,
            img,
            imgWidth,
            career,
            title,
            firstDesc,
            secondDesc,
          }) => (
            <S.Slide key={id}>
              <S.Profile>
                <S.Name>{name}</S.Name>
                <S.Specialty>{specialty}</S.Specialty>

                <S.Career>
                  {career.map((item) => (
                    <p key={item}> {item}</p>
                  ))}
                </S.Career>
                <S.ImageWrapper>
                  <Image src={img} width={imgWidth} height={205} alt={"card"} />
                </S.ImageWrapper>
              </S.Profile>
              <S.Message>
                <S.MessageTitle>{title}</S.MessageTitle>
                <S.ProjectDescription>{firstDesc}</S.ProjectDescription>
                <S.ProjectDescription>{secondDesc}</S.ProjectDescription>
              </S.Message>
            </S.Slide>
          )
        )}
      </S.CardContainer>
    </S.Wrapper>
  );
}
